// extracted by mini-css-extract-plugin
module.exports = {"label":"PastProgramsToggle_label__46IKE","text":"PastProgramsToggle_text__704Lf"};